const types = {
    SET_VIEW_BONUSES: '[BONUSES] SET VIEW BONUSES',
    SET_LIST: '[BONUSES] SET LIST BONUSES'
}

export {
    types
}